import React, { useEffect } from "react";
import moment from "moment";
import icoStar from "src/assets/images/icoStar.svg";
import icoStarActive from "src/assets/images/icoStarActive.svg";
import cn from "classnames";
import styled from "styled-components";

interface IstartProps {
  score: number;
  date: string;
  assessor: string;
  contents: string;
}

const ScoreComment = (props: IstartProps) => {
  return (
    <ScoreCommentBox>
      <div>
        <div>
          {props.score >= 0 ? (
            <span className={cn("star-score", { active: props.score >= 0 })}>{props.score}</span>
          ) : (
            <span className={cn("star-score")}>{`-`}</span>
          )}
        </div>
        <div>{props.contents ? props.contents : "코멘트가 없습니다."}</div>
      </div>
      <p>
        <span className="name">{props.assessor}</span>
        <span className="date">{moment(props.date).format("YYYY.MM.DD HH:mm")}</span>
      </p>
    </ScoreCommentBox>
  );
};

const ScoreCommentBox = styled.div`
  > div {
    ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "stretch")}
    margin-bottom: 16px;
    border-top: 1px solid ${({ theme }) => theme.color.linePrimary};
    border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
    > div:first-child {
      flex-shrink: 0;
      ${({ theme }) => theme.flexBox.flexMixin("column", "center", "center")}
      padding: 8px 16px 8px 8px;
      border-right: 1px solid ${({ theme }) => theme.color.linePrimary};
    }
    > div:last-child {
      flex: 0 1 auto;
      padding: 8px 8px 8px 16px;
      color: ${({ theme }) => theme.color.tertiary};
      line-height: 20px;
    }
  }
  > p {
    color: ${({ theme }) => theme.color.tertiary};
    font-size: 12px;
    .name {
      position: relative;
      display: inline-block;
      padding-right: 8px;
      margin-right: 8px;
      &:after {
        content: "";
        position: absolute;
        right: 0;
        top: 50%;
        display: block;
        width: 2px;
        height: 10px;
        margin-top: -5px;
        background-color: ${({ theme }) => theme.color.lineSecondary};
      }
    }
    .date {
      font-family: "Poppins";
    }
  }
  .star-score {
    position: relative;
    top: 1px;
    display: inline-block;
    padding-left: 18px;
    font-family: "Poppins";
    line-height: 20px;
    background: url(${icoStar}) no-repeat left 2px;
    &.active {
      background: url(${icoStarActive}) no-repeat left 2px;
    }
  }
`;

export default ScoreComment;
